/**
 * debtPlanFormat.js — shared phrasing for the debt plan surfaces.
 *
 * Every label here is derived from the backend model. Nothing invents a claim
 * the payload doesn't support.
 */
export function longMonth(iso) {
  if (!iso) return null;
  try {
    return new Date(iso).toLocaleDateString(undefined, { month: 'long', year: 'numeric' });
  } catch { return iso; }
}

export function shortDate(iso) {
  if (!iso) return null;
  try {
    return new Date(iso).toLocaleDateString(undefined, { day: 'numeric', month: 'short' });
  } catch { return iso; }
}

export function horizon(months) {
  if (!months) return null;
  const y = Math.floor(months / 12);
  const m = months % 12;
  if (y && m) return `${y}y ${m}m`;
  return y ? `${y}y` : `${m}m`;
}

export function dueLabel(item) {
  if (!item) return null;
  if (item.overdue) {
    const d = Math.abs(item.days_away);
    return d === 0 ? 'due today' : `overdue by ${d} day${d === 1 ? '' : 's'}`;
  }
  if (item.days_away === 0) return 'due today';
  return `due in ${item.days_away} day${item.days_away === 1 ? '' : 's'}`;
}

export const SOURCE_LABEL = {
  statement: 'from your statement',
  recurring_rule: 'from your recurring payment',
  derived_from_history: 'worked out from your payment history',
};

export const CONFIDENCE_LABEL = {
  high: 'Based on complete details',
  medium: 'Some details are assumed',
  low: 'Missing or ageing details',
};
